import styled from '@emotion/styled'
import SupportIcon from 'src/assets/images/nav/ic_support.svg'
import KnowledgeBaseIcon from 'src/assets/images/nav/ic_knowledge_base.svg'
import ExternalLinkIcon from 'src/assets/images/nav/ic_external_link.svg'
import { ButtonText } from 'src/ui-kit/text/Text'
import { NavIcon } from 'src/components/parts/navigation/MainNav'
import * as colors from 'src/ui-kit/colors/colors'

interface Props {
    expanded: boolean
}

export const SupportSection = ({ expanded }: Props) => {
    return (
        <>
            <ButtonText $color={colors.coral} style={{ margin: '33px 0 0 20px', height: '20px' }}>
                {expanded && 'SUPPORT & INFO'}
            </ButtonText>
            <Support expanded={expanded} />
            <KnowledgeBase expanded={expanded} />
        </>
    )
}

const KnowledgeBase = ({ expanded }: Props) => {
    return (
        <SupportLink
            href='https://voidev.atlassian.net/wiki/spaces/RND/pages/80321249288/FM+app'
            target='_blank'
            rel='noopener noreferrer'
            data-testid='visit-knowledge-base-link'
        >
            <NavIcon $expanded={expanded} src={KnowledgeBaseIcon} alt='Knowledge base' />
            {expanded && (
                <TitleSubtitleWrapper>
                    <ButtonText $color={colors.white}>
                        KNOWLEDGE BASE <ExternalLinkImg src={ExternalLinkIcon} />
                    </ButtonText>
                    <Subtitle>Useful information of the system and features</Subtitle>
                </TitleSubtitleWrapper>
            )}
        </SupportLink>
    )
}

const Support = ({ expanded }: Props) => {
    return (
        <SupportLink
            href='https://voiapp.slack.com/archives/CEN37NR19'
            target='_blank'
            rel='noopener noreferrer'
            data-testid='visit-support-link'
        >
            <NavIcon $expanded={expanded} src={SupportIcon} alt='Support' />
            {expanded && (
                <TitleSubtitleWrapper>
                    <ButtonText $color={colors.white}>
                        SUPPORT <ExternalLinkImg src={ExternalLinkIcon} />
                    </ButtonText>
                    <Subtitle>Use Slack to report issues, get technical support or request features</Subtitle>
                </TitleSubtitleWrapper>
            )}
        </SupportLink>
    )
}

const SupportLink = styled.a`
    display: flex;
    align-items: start;
    margin-bottom: 16px;
    padding: 0 20px;
    opacity: 0.5;

    &:hover {
        opacity: 1;
    }
`

const TitleSubtitleWrapper = styled.div`
    display: flex;
    flex-direction: column;
`

const Subtitle = styled.div`
    margin-top: 8px;
    font-size: 13px;
    color: ${colors.white};
`

const ExternalLinkImg = styled.img`
    height: 11px;
    width: 11px;
`
